import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectActiveInvite, selectCoopInfo, selectInvitingCoopInfo, } from "../../selectors/selectCoopInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonDelete } from "../generic/common/ButtonDelete";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopInfoJoinCoop, actionCoopInfoPlayerCancelInvite } from "./actionCoop";
export var _dialogCoopInvitation = function (_a) {
    var activeInvite = _a.activeInvite, currentCoop = _a.currentCoop, invitingCoop = _a.invitingCoop, onClose = _a.onClose, onJoin = _a.onJoin, onReject = _a.onReject;
    var inviteLocaReplacements = new Map([
        [ReplacementLoca.zero_0, activeInvite.hostName],
        [ReplacementLoca.one_1, invitingCoop.name],
    ]);
    var notice;
    if (currentCoop) {
        var noticeLocaReplacements = new Map([[ReplacementLoca.zero_0, currentCoop.name]]);
        notice = (React.createElement("div", { className: IdStyles.CoopInvitationNoticeBackground + " coop-invite-dialog__notice" },
            React.createElement(TextLoca, { id: IdLoca.coopInvitationDialog_desc2, className: IdStyles.TextNormal, replacements: noticeLocaReplacements })));
    }
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.coopInvitationDialog_title, onClose: onClose, className: IdStyles.ModalBackgroundInfo },
        React.createElement("div", { className: "coop-invite-dialog" },
            React.createElement("div", { className: IdStyles.CoopInvitationBackground + " coop-invite-dialog__main-container" },
                React.createElement("div", { className: "coop-invite-dialog__main-container-left" },
                    React.createElement("div", { className: "coop-invite-dialog__titlerow" },
                        React.createElement("div", { className: IdStyles.CoopInvitationLevelBackground + " coop-invite-dialog__coop-level" },
                            React.createElement(Icon, { icon: IdIcon.CoopXpIcn, styleId: IdStyles.IconSmall },
                                React.createElement("div", { className: "flex flex--guts h100" },
                                    React.createElement(NumberFormat, { amount: invitingCoop.level, className: IdStyles.TextSmallBoldSecondaryOutline }))),
                            React.createElement(Icon, { icon: IdIcon.CooperativeIcn, styleId: IdStyles.IconSmall })),
                        React.createElement("div", { className: IdStyles.CoopInvitationTitleBackground + " " + IdStyles.TextNormal + " coop-invite-dialog__coop-title" }, invitingCoop.name)),
                    React.createElement("div", { className: IdStyles.CoopInvitationDescriptionBackground + " " + IdStyles.TextNormal + " coop-invite-dialog__coop-description" }, invitingCoop.description)),
                React.createElement("div", { className: "coop-invite-dialog__main-container-right" },
                    React.createElement("div", { className: "coop-invite-dialog__invite-description" },
                        React.createElement(TextLoca, { id: IdLoca.coopInvitationDialog_desc1, className: IdStyles.TextNormal, replacements: inviteLocaReplacements })),
                    notice)),
            React.createElement("div", { className: "coop-invite-dialog__button-container" },
                React.createElement(ButtonDelete, { onClick: onReject },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.reject })),
                React.createElement(ButtonPrimary, { onClick: onJoin(activeInvite.coopId) },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.join }))))));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.CoopInvitation)); },
    onJoin: function (coopId) { return function () {
        if (coopId !== undefined) {
            dispatch(actionCoopInfoJoinCoop({ coopId: coopId }));
        }
        dispatch(actionModalClose(IdModal.CoopInvitation));
    }; },
    onReject: function () {
        dispatch(actionCoopInfoPlayerCancelInvite());
        dispatch(actionModalClose(IdModal.CoopInvitation));
    },
}); };
var mapState = function (state) {
    return {
        activeInvite: selectActiveInvite(state),
        currentCoop: selectCoopInfo(state),
        invitingCoop: selectInvitingCoopInfo(state),
    };
};
export var DialogCoopInvitation = connect(mapState, mapDispatch)(_dialogCoopInvitation);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogInvitation.tsx
// module id = 2569
// module chunks = 3